import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-id" }
const _hoisted_2 = { class: "muted" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "muted"
}
const _hoisted_5 = {
  key: 1,
  class: "muted"
}
const _hoisted_6 = {
  key: 1,
  class: "muted"
}

import { onMounted, reactive, ref } from 'vue'
import request from '@/utils/request'
import { previewImage, thumbnail } from '@/utils/image'

type CompositionTask = {
  id: number
  task_id: string
  user_id: number
  source_object_key: string
  object_key: string
  final_image_url: string
  recommended_filter_id: string
  applied_filter_id: string
  error_code: string
  error_message: string
  status: string
  created_at: string
  received_at?: string
  final_received_at?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompositionWorkList',
  setup(__props) {

const loading = ref(false)
const records = ref<CompositionTask[]>([])
const filters = reactive({ task_id: '', user_id: '', status: undefined as string | undefined, createdRange: null as string[] | null })
const pagination = reactive({ total: 0, current: 1, pageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'], showTotal: (total: number) => `共 ${total} 条` })
const statusOptions = [
  { label: '待构图回传', value: 'receive_result' },
  { label: '已构图', value: 'composed' },
  { label: '已完成', value: 'completed' },
  { label: '失败', value: 'failed' },
]
const columns = [
  { title: '任务 ID', key: 'task_id', slots: { customRender: 'task_id' }, width: 220 },
  { title: '用户 ID', key: 'user_id', slots: { customRender: 'user_id' }, width: 100 },
  { title: '原始照片', key: 'source_image', slots: { customRender: 'source_image' }, width: 150 },
  { title: '构图结果', key: 'composed_image', slots: { customRender: 'composed_image' }, width: 150 },
  { title: '最终作品', key: 'final_image', slots: { customRender: 'final_image' }, width: 150 },
  { title: '状态', key: 'status', slots: { customRender: 'status' }, width: 130 },
  { title: '滤镜', key: 'filters', slots: { customRender: 'filters' }, width: 180 },
  { title: '回传时间', key: 'received_at', slots: { customRender: 'received_at' }, width: 180 },
  { title: '创建时间', key: 'created_at', slots: { customRender: 'created_at' }, width: 160 },
]

async function loadRecords(page = pagination.current, pageSize = pagination.pageSize) {
  loading.value = true
  try {
    const params: Record<string, unknown> = {
      offset: (page - 1) * pageSize,
      limit: pageSize,
      task_id: filters.task_id.trim() || undefined,
      user_id: filters.user_id.trim() || undefined,
      status: filters.status || undefined,
      start_at: filters.createdRange?.[0] || undefined,
      end_at: filters.createdRange?.[1] || undefined,
    }
    const response: any = await request.get('/api/composition/tasks', params)
    records.value = response?.data?.list || []
    pagination.total = response?.data?.pagination?.total || 0
    pagination.current = page
    pagination.pageSize = pageSize
  } finally {
    loading.value = false
  }
}

function search() {
  loadRecords(1, pagination.pageSize)
}

function resetFilters() {
  filters.task_id = ''
  filters.user_id = ''
  filters.status = undefined
  filters.createdRange = null
  search()
}

function handleTableChange(pager: any) {
  loadRecords(pager.current, pager.pageSize)
}

function formatTime(value?: string) {
  if (!value) return '-'
  return value.replace('T', ' ').replace(/\.\d+(Z|[+-]\d{2}:?\d{2})?$/, '').replace(/Z$/, '')
}

function statusLabel(status: string) {
  return ({ receive_result: '待构图回传', composed: '已构图', completed: '已完成', failed: '失败' } as Record<string, string>)[status] || status || '-'
}

function statusColor(status: string) {
  return ({ receive_result: 'processing', composed: 'blue', completed: 'success', failed: 'error' } as Record<string, string>)[status] || 'default'
}

onMounted(() => loadRecords())

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "构图作品列表" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "inline",
        model: filters,
        class: "search-form",
        onFinish: search
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "任务 ID" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: filters.task_id,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filters.task_id) = $event)),
                "allow-clear": "",
                placeholder: "请输入任务 ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "用户 ID" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: filters.user_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.user_id) = $event)),
                "allow-clear": "",
                placeholder: "请输入用户 ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: filters.status,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((filters.status) = $event)),
                "allow-clear": "",
                placeholder: "全部状态",
                options: statusOptions,
                class: "status-select"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "创建时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: filters.createdRange,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((filters.createdRange) = $event)),
                "show-time": "",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD HH:mm"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("查询", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, { onClick: resetFilters }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("重置", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_a_table, {
        "row-key": "id",
        columns: columns,
        "data-source": records.value,
        loading: loading.value,
        pagination: pagination,
        scroll: { x: 1380 },
        onChange: handleTableChange
      }, {
        task_id: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(record.task_id), 1),
          _createElementVNode("div", _hoisted_2, "记录 #" + _toDisplayString(record.id), 1)
        ]),
        user_id: _withCtx(({ record }) => [
          _createElementVNode("a", {
            onClick: ($event: any) => {filters.user_id = String(record.user_id); search()}
          }, _toDisplayString(record.user_id || '-'), 9, _hoisted_3)
        ]),
        source_image: _withCtx(({ record }) => [
          (record.source_object_key)
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 0,
                src: _unref(thumbnail)(record.source_object_key),
                preview: { src: _unref(previewImage)(record.source_object_key) },
                class: "work-image"
              }, null, 8, ["src", "preview"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "无原图"))
        ]),
        composed_image: _withCtx(({ record }) => [
          (record.object_key)
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 0,
                src: _unref(thumbnail)(record.object_key),
                preview: { src: _unref(previewImage)(record.object_key) },
                class: "work-image"
              }, null, 8, ["src", "preview"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
        ]),
        final_image: _withCtx(({ record }) => [
          (record.final_image_url)
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 0,
                src: _unref(thumbnail)(record.final_image_url),
                preview: { src: _unref(previewImage)(record.final_image_url) },
                class: "work-image"
              }, null, 8, ["src", "preview"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
        ]),
        status: _withCtx(({ record }) => [
          _createVNode(_component_a_tag, {
            color: statusColor(record.status)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(statusLabel(record.status)), 1)
            ]),
            _: 2
          }, 1032, ["color"]),
          (record.error_message)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: record.error_message
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tag, { color: "error" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.error_code || '错误详情'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["title"]))
            : _createCommentVNode("", true)
        ]),
        filters: _withCtx(({ record }) => [
          _createElementVNode("div", null, "推荐：" + _toDisplayString(record.recommended_filter_id || '-'), 1),
          _createElementVNode("div", null, "应用：" + _toDisplayString(record.applied_filter_id || '-'), 1)
        ]),
        created_at: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(formatTime(record.created_at)), 1)
        ]),
        received_at: _withCtx(({ record }) => [
          _createElementVNode("div", null, "构图：" + _toDisplayString(formatTime(record.received_at)), 1),
          _createElementVNode("div", null, "成片：" + _toDisplayString(formatTime(record.final_received_at)), 1)
        ]),
        _: 1
      }, 8, ["data-source", "loading", "pagination"])
    ]),
    _: 1
  }))
}
}

})